import Link from 'components/Link';
import palette from 'theme/palette';

export default {
	defaultProps: {
		component: Link,
		underline: 'none' as const,
	},
	styleOverrides: {
		root: {
			color: palette.primary.main,
			fontSize: '14px',
			lineHeight: '20px',

			'&.MuiLink-underlineAlways': {
				borderBottom: `1px solid ${palette.text.primary}`,
				textDecoration: 'none',
			},
		},
	},
};
